import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from './icon.component';
import { BtnComponent } from './btn.component';
import { TranslatePipe } from '../pipes/translate.pipe';

/** Centered empty / no-results state with icon, title, sub, optional action. */
@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [NgIf, IconComponent, BtnComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div style="text-align:center;padding:50px 32px">
      <div style="width:72px;height:72px;border-radius:20px;background:var(--fr-surface-3);display:inline-flex;
           align-items:center;justify-content:center;margin-bottom:16px">
        <app-icon [name]="icon" [size]="34" color="var(--fr-text-3)"></app-icon>
      </div>
      <h3 style="margin:0;font-size:17px;font-weight:750;color:var(--fr-text)">{{ title | t }}</h3>
      <p *ngIf="sub" style="margin:6px 0 0;font-size:13.5px;color:var(--fr-text-2);line-height:1.5">{{ sub | t }}</p>
      <div *ngIf="action" style="margin-top:18px">
        <app-btn (act)="act.emit()">{{ action | t }}</app-btn>
      </div>
    </div>`,
})
export class EmptyStateComponent {
  @Input() icon = 'solar:magnifer-linear';
  @Input() title = '';
  @Input() sub?: string;
  @Input() action?: string;
  @Output() act = new EventEmitter<void>();
}
